/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Text from '../text';
import s from './styles.module.scss';

const GeneralFormError = ({ error, className = null }) =>
  error ? (
    <div className={s.error}>
      <Text className={cx(s.errorText, className)}>{error}</Text>
    </div>
  ) : null;

GeneralFormError.propTypes = {
  error: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default GeneralFormError;
